import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const ProjectColumns = (props) => {
  const projectColumns: any = [
    {
      name: props.t('Project_Name'),
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: props.t('Start_Date'),
      selector: (row) => {
        const startDate = new Date(row.startDate);
        const day = startDate.getDate().toString().padStart(2, '0');
        const month = (startDate.getMonth() + 1).toString().padStart(2, '0');
        const year = startDate.getFullYear();

        return `${day}/${month}/${year}`;
      },
      sortable: true,
      center: true,
    },
    {
      name: props.t('End_Date'),
      selector: (row) => {
        const endDate = new Date(row.endDate);
        const day = endDate.getDate().toString().padStart(2, '0');
        const month = (endDate.getMonth() + 1).toString().padStart(2, '0');
        const year = endDate.getFullYear();

        return `${day}/${month}/${year}`;
      },
      sortable: true,
      center: true,
    },
    {
      id: 'Action',
      name: props.t('actions'),
      selector: (row) => row.action,
      sortable: false,
      center: true,
    },
  ];
  return <DataTable columns={projectColumns} data={props.data} />;
};
export default translate(ProjectColumns);
